// removed by extract-text-webpack-plugin
module.exports = {"container":"guest-list-preview__container__1BFQL","text":"guest-list-preview__text__21Lic","avatars-container":"guest-list-preview__avatars-container__3uMpf","avatar":"guest-list-preview__avatar__2ME9S"};


//////////////////
// WEBPACK FOOTER
// ./src/components/details/guest-list-preview.scss
// module id = 1321
// module chunks = 1